import React, { Component } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Row,
  FormGroup,
  Label,
  Button,
  CardImg,
} from "reactstrap";
import {
  ValidationForm,
  TextInput,
  SelectGroup,
  FileInput,
  Radio,
} from "react-bootstrap4-form-validation";
import validator from "validator";
import { Link, Redirect } from "react-router-dom";
import apiPath from "../../constants/apiPath";
import _ from "lodash";
import Http from "../../services/Http";
import { AlertList } from "react-bs-notifier";
import helper from "../../constants/helper";
import no_image from "../../assets/img/brand/no_image.png";
import CSVReader from "react-csv-reader";


class ImportProduct extends Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      loading: false,
      immediate: true,
      setFocusOnError: true,
      clearInputOnReset: true,
      position: "top-right",
      alerts: [],
      timeout: 5000,
      service: [],
      category: [],
      subcategory: [],
      message: "",
      photo: "",
      l_name: "",
      name: "",
      price: "",
      categoryId: "",
      serviceId: "",
      // subCategoryId:'',
      weight: "",
      qty: "",
      featured: "No",
      part_number: "",
      hs_number: "",
      csvErroMessage: "",
      partShow: "shide",
      excelData: []
    };
  }

  componentDidMount() {
    this.getService();
    // this.getCategory();
    // this.getSubCategory();
  }

  generate(type) {
    this.clearAlerts();
    const newAlert = {
      id: new Date().getTime(),
      type: type,
      headline: "",
      message: this.state.message,
    };

    this.setState({
      alerts: [...this.state.alerts, newAlert],
    });
  }

  clearAlerts() {
    this.setState({
      alerts: [],
    });
  }

  onAlertDismissed(alert) {
    const alerts = this.state.alerts;
    const idx = alerts.indexOf(alert);
    if (idx >= 0) {
      this.setState({
        alerts: [...alerts.slice(0, idx), ...alerts.slice(idx + 1)],
      });
    }
  }
  message() {
    if (!_.isEmpty(this.state.message)) {
      return (
        <AlertList
          position={this.state.position}
          alerts={this.state.alerts}
          timeout={this.state.timeout}
          dismissTitle=""
          onDismiss={this.onAlertDismissed.bind(this)}
        />
      );
    }
  }

  handleChange = (e) => {
    let partNumber;
    let hsNumber;
    if (e.target.name === "serviceId") {
      this.setState({ category: [] });
      this.setState({ subcategory: [] });
      this.setState({ message: "Please select service first." });
      this.setState({ loading: true });
      this.getCategory(e.target.value);
      this.setState(
        {
          [e.target.name]: e.target.value,
        },
        function () {
          this.setState({ loading: false });
        }
      );

      if (e.target.value == 2) {
        this.setState({
          partShow: "bshow",
        });

      } else {
        this.setState({
          partShow: "shide",
        });

      }
    } else if (e.target.name === "categoryId") {
      this.setState({ message: "Please select category first." });
      this.setState({ loading: true });
      this.getSubCategory(e.target.value);
      this.setState(
        {
          [e.target.name]: e.target.value,
        },
        function () {
          this.setState({ loading: false });
        }
      );
    } else {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
  };


  handleSubmit = (e, formData, inputs) => {
    e.preventDefault();
    if (this.validate(formData)) {
      this.ImportProduct(formData)
        .then((resultData) => {
          if (resultData.success) {
            this.setState({ message: resultData.msg });
            this.generate("success");
            this.resetForm();
          } else {
            this.setState({ message: resultData.msg });
            this.generate("danger");
          }
        })
        .catch((err) => {
          this.setState({ message: err.message });
          this.generate("danger");
        });
    }
  };

  validate(formData) {
    let isValid = true;
    if (!isNaN(formData.name)) {
      isValid = false;
      this.setState(
        { message: "Name must be containing alphabets only." },
        function () {
          this.generate("warning");
        }
      );
    }
    return isValid;
  }

  handleErrorSubmit = (e, formData, errorInputs) => { };

  resetForm = () => {
    let formRef = this.formRef.current;
    formRef.resetValidationState(this.state.clearInputOnReset);
    this.setState({
      name: "",
      l_name: "",
      photo: "",
      descriptions: "",
      l_descriptions: "",
      categoryId: "",
      subCategoryId: "",
      weight: "",
      unit: "Kg",
      price: "",
    });
  };

  async ImportProduct(postData) {
    if (this.state.excelData.length <= 0) {
      this.setState({ csvErroMessage: "Csv file should not be empty." });
      return false;
    }

    this.setState({ csvErroMessage: "" });
    let path = apiPath.ImportProduct;
    this.setState({ loading: true });
    var data = new FormData();
    postData.excelData = this.state.excelData;
    data.append("addData", JSON.stringify(postData));
    let options = {
      method: "POST",
      headers: {},
      body: data,
    };
    let result = await Http(path, options);
    this.setState({ loading: false });
    if (result.ok) {
      if (result.status === 200) {
        let resultData = await result.json();
        if (resultData.success) {
          setTimeout(() => {
            this.setState({ redirectTo: true });
          }, 1500);
        }
        return resultData;
      } else {
        this.setState({ message: "Something went wrong, please try again." });
        this.generate("danger");
      }
    } else {
      this.setState({ message: result.statusText });
      this.generate("danger");
    }

  }

  async getService() {
    let path = apiPath.getAllService;
    this.setState({ loading: true });
    let options = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    let result = await Http(path, options);
    this.setState({ loading: false });
    if (result.ok) {
      if (result.status === 200) {
        let resultData = await result.json();
        if (resultData.success) {
          this.setState({ service: resultData.result });
        }
      }
    } else {
      console.log(result);
      this.setState({ message: result.statusText });
      this.generate("danger");
    }
  }

  service() {
    if (!_.isEmpty(this.state.service)) {
      return this.state.service.map((make, index) => {
        if (make.id != 1) {
          return (
            <option key={index} id={index} value={make.id}>
              {make.name}
            </option>
          );
        }
      });
    }
  }

  async getCategory(serviceId = "") {
    let path = apiPath.getAllCategory;
    this.setState({ loading: true });
    let options = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    let result = await Http(path + "?serviceId=" + serviceId, options);
    // let result = await Http(path, options);
    this.setState({ loading: false });
    if (result.ok) {
      if (result.status === 200) {
        let resultData = await result.json();
        if (resultData.success) {
          this.setState({ category: resultData.result });
        }
      }
    } else {
      console.log(result);
      this.setState({ message: result.statusText });
      this.generate("danger");
    }
  }

  handleForce = (data, fileInfo) => {
    const nonEmptyRows = data.filter(row => row.join('').trim() !== '');
    this.setState({ excelData: nonEmptyRows });

    if (this.state.excelData && this.state.excelData.length > 0) {
      this.setState({ csvErroMessage: "" });
    }

    // this.importShipmentData(data);
  };

  async importShipmentData(data1) {
    let path = apiPath.addERPDataByCsv;
    this.setState({ loading: true });
    var data = new FormData();
    data.append("addData", JSON.stringify(data1));
    let options = {
      method: "PUT",
      headers: {},
      body: data,
    };
    let result = await Http(
      path + "?user_id=" + this.state.adminData.admin.id,
      options
    );
    this.setState({ loading: false });
    if (result.ok) {
      if (result.status === 200) {
        let resultData = await result.json();
        if (resultData.success == true) {
          this.setState({ message: resultData.msg });
          this.generate("success");
        }
      }
    } else {
      this.setState({ message: result.statusText });
      this.generate("danger");
    }
  }

  async getSubCategory(categoryId = "") {
    let path = apiPath.getAllSubCategoriesTree;
    this.setState({ loading: true });
    let options = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    let result = await Http(path + "?categoryId=" + categoryId, options);
    this.setState({ loading: false });
    if (result.ok) {
      if (result.status === 200) {
        let resultData = await result.json();
        if (resultData.success) {
          this.setState({ subcategory: resultData.result });
        }
      }
    } else {
      console.log(result);
      this.setState({ message: result.statusText });
      this.generate("danger");
    }
  }

  category() {
    if (!_.isEmpty(this.state.category)) {
      return this.state.category.map((make, index) => {
        return (
          <option key={index} id={index} value={make.id}>
            {make.name}
          </option>
        );
      });
    }
  }

  clickCsvDownload = () => {
    let fileUrl = process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "https://backend.buyandbee.com/product_sample.csv";
    let file = "product_sample.csv";
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = file;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  render() {
    if (this.state.redirectTo) {
      return <Redirect to="/items/products" />;
    }
    return (
      <div>
        <Row>
          <Col xs="12" sm="12">
            {this.message()}
            <Card>
              <CardHeader>
                <p>
                  <h4>Add Product</h4>
                </p>
              </CardHeader>
              <ValidationForm
                onSubmit={this.handleSubmit}
                onErrorSubmit={this.handleErrorSubmit}
                ref={this.formRef}
                immediate={this.state.immediate}
                setFocusOnError={this.state.setFocusOnError}
                defaultErrorMessage={{ required: "Please enter something." }}
              >
                <CardBody className="card_form_body">
                  <Row>
                    <Col md="8">

                      {/* <Row>
                        <Col xs="6" md="6" xl="6">
                          <FormGroup>
                            <Label htmlFor="name">
                              Select Service{" "}
                              <span className="red_color">*</span>
                            </Label>
                            <SelectGroup
                              name="serviceId"
                              id="serviceId"
                              onChange={this.handleChange}
                              required
                              errorMessage="Please select service"
                            >
                              <option value="">Select Service</option>
                              {this.service()}
                            </SelectGroup>
                          </FormGroup>
                        </Col>

                        <Col xs="5" md="5" xl="5">
                          <FormGroup>
                            <Label htmlFor="name">
                              Select Category{" "}
                              <span className="red_color">*</span>
                            </Label>
                            <SelectGroup
                              name="categoryId"
                              id="categoryId"
                              onChange={this.handleChange}
                              required
                              errorMessage="Please select category"
                            >
                              <option value="">Select Category</option>
                              {this.category()}
                            </SelectGroup>
                          </FormGroup>
                        </Col>
                      </Row> */}

                      <Row>
                        <Col xs="6" md="6" xl="6">
                          <Label htmlFor="name" className="text-danger">You can download the sample file for bulk upload</Label>{" "}
                          <Button
                            onClick={this.clickCsvDownload}
                            size="sm"
                            color="primary"
                          >
                            <i className="fa fa-download"></i> Sample File
                          </Button>
                        </Col>
                      </Row>

                      <Row className="mt-2">
                        <Col xs="6" md="4" xl="4">
                          <Label htmlFor="name"> Select CSV File{" "} <span className="red_color">*</span></Label>
                          <div className="mb-2"> {/* filter_btns */}
                            <CSVReader
                              cssClass="csv-reader-input"
                              onFileLoaded={this.handleForce}
                              onError={this.handleDarkSideForce}
                              parserOptions={this.papaparseOptions}
                              inputId="ObiWan"
                              inputName="ObiWan"
                              inputStyle={{ color: "green" }}
                            />
                          </div>
                          <span className="red_color">{this.state.csvErroMessage != "" ? this.state.csvErroMessage : ""}</span>
                        </Col>
                      </Row>
                    </Col>

                    {/* <Col md="4">
                      <Row>
                        <Col xs="12">
                          <FormGroup>
                            <Label htmlFor="subCategoryId">
                              Subcategory For
                            </Label>
                            {this.state.subcategory.map((make, index) => (
                              <>
                                <div
                                  className="tree-item active has-children childId_"
                                  key={make.id}
                                >
                                  <span className="radio">
                                    <input
                                      type="radio"
                                      name="subCategoryId"
                                      onChange={this.handleChange}
                                      value={make.id}
                                    />
                                    <label> {make.name}</label>
                                  </span>
                                  {make.Childs.map((makess, indexss) => (
                                    <>
                                      <div
                                        className="tree-item active has-children"
                                        onChange={this.handleChange}
                                        key={makess.id}
                                      >
                                        <span className="radio">
                                          <input
                                            type="radio"
                                            name="subCategoryId"
                                            value={makess.id}
                                          />
                                          <label> {makess.name}</label>
                                        </span>
                                        {makess.Childssss.map(
                                          (makessssss, indexsssss) => (
                                            <div
                                              className="tree-item active has-children"
                                              onChange={this.handleChange}
                                              key={makessssss.id}
                                            >
                                              <span className="radio">
                                                <input
                                                  type="radio"
                                                  name="subCategoryId"
                                                  value={makessssss.id}
                                                />
                                                <label>
                                                  {" "}
                                                  {makessssss.name}
                                                </label>
                                              </span>

                                              {makessssss.Childs3.map(
                                                (makes3, indexs3) => (
                                                  <div
                                                    className="tree-item active has-children"
                                                    onChange={this.handleChange}
                                                    key={makes3.id}
                                                  >
                                                    <span className="radio">
                                                      <input
                                                        type="radio"
                                                        name="subCategoryId"
                                                        value={makes3.id}
                                                      />
                                                      <label>
                                                        {" "}
                                                        {makes3.name}
                                                      </label>
                                                    </span>

                                                    {makes3.Childs4.map(
                                                      (makes4, indexs4) => (
                                                        <div
                                                          className="tree-item active has-children"
                                                          onChange={
                                                            this.handleChange
                                                          }
                                                          key={makes4.id}
                                                        >
                                                          <span className="radio">
                                                            <input
                                                              type="radio"
                                                              name="subCategoryId"
                                                              value={makes4.id}
                                                            />
                                                            <label>
                                                              {" "}
                                                              {makes4.name}
                                                            </label>
                                                          </span>
                                                        </div>
                                                      )
                                                    )}
                                                  </div>
                                                )
                                              )}
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </>
                                  ))}
                                </div>
                              </>
                            ))}
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col> */}
                  </Row>
                </CardBody>
                <CardFooter>
                  <Button
                    disabled={this.state.loading}
                    type="submit"
                    size="sm"
                    color="primary"
                  >
                    <i className="fa fa-check"></i> Save
                  </Button>
                  &nbsp;
                  <Button
                    type="reset"
                    tag={Link}
                    to={"/items/products"}
                    size="sm"
                    color="outline-info"
                  >
                    <i className="fa fa-arrow-left"></i> Back
                  </Button>
                </CardFooter>
              </ValidationForm>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default ImportProduct;
